import React from "react";
import Navbar from "../components/layout/Navbar";
import Reveal from "../components/common/Reveal";
import Footer from "../components/layout/Footer";
import FounderImage from "../assets/images/founder.jpeg";

type FacultyMember = {
  id: string;
  name: string;
  role: string;
  image: string;
  bio: string;
  specialties: string[];
};

const FACULTY_MEMBERS: FacultyMember[] = [
  {
    id: "1",
    name: "Sarah Johnson",
    role: "Lead Instructor",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&h=800&fit=crop",
    bio: "With over 15 years of experience teaching ukulele, Sarah brings passion and expertise to every session. Her patient approach helps students of all levels find their rhythm and build confidence through structured learning paths.",
    specialties: ["Beginner Foundations", "Strumming Patterns", "Song Arrangement"],
  },
  {
    id: "2",
    name: "Michael Chen",
    role: "Advanced Techniques Specialist",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=800&fit=crop",
    bio: "Michael specializes in fingerpicking and advanced strumming patterns. He's performed at festivals worldwide and loves sharing his performance insights, helping students transition from practice to stage.",
    specialties: ["Fingerpicking", "Performance Techniques", "Festival Prep"],
  },

];

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-primary">
      <Navbar />

      {/* Founder Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary via-accentGold/5 to-accentNavy/10">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-gradient-to-br from-accentNavy/20 via-transparent to-accentGold/15" />
        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-accentGold/10 to-accentNavy/25" />
        <div className="absolute -right-32 top-1/2 h-96 w-96 rounded-full bg-accentGold/30 blur-3xl" />
        <div className="absolute -left-32 bottom-1/4 h-96 w-96 rounded-full bg-accentNavy/20 blur-3xl" />

        <div className="relative z-10 mx-auto max-w-7xl px-6 py-32 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Image Side */}
            <Reveal className="order-2 lg:order-1">
              <div className="relative">
                <div className="relative aspect-[4/4] max-w-s sm:max-w-md md:max-w-lg mx-auto lg:max-w-xl">
                  <img
                    src={FounderImage}
                    alt="Girish Mathur - Founder"
                    className="w-full h-full object-cover rounded-[18px] shadow-[0_50px_100px_-30px_rgba(9,32,63,0.6)]"
                  />
                  <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-accentGold/20 rounded-full blur-2xl" />
                  <div className="absolute -top-6 -left-6 w-40 h-40 bg-accentNavy/10 rounded-full blur-2xl" />
                </div>
              </div>
            </Reveal>

            {/* Content Side */}
            <Reveal delay={120} className="order-1 lg:order-2 space-y-8">
              <div className="space-y-4">
                <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/45 font-semibold">
                  Our Story
                </p>
                <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-5xl text-accentNavy leading-tight">
                  Meet the Founder
                </h1>
              </div>

              <div className="space-y-2">
                <h2 className="text-3xl sm:text-4xl font-semibold text-accentNavy pb-2">
                  Girish Mathur
                </h2>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-accentGold">
                  Founder & Passionate Musician
                </p>
              </div>

              <div className="space-y-6 text-base sm:text-lg text-accentNavy/70 leading-relaxed">
              <p>
                    Girish is a passionate musician , who has been learning guitar for more than one and a half <b>decade</b> now. His love for strings transcends into amuse for the <b>Ukulele</b> as well, becoming his first choice of instrument for playing instant compositions and soothing melodies while travelling.
                  </p>
                  <p>
                    He has been teaching offline since 2015, but switched to online teaching pre-covid in 2019, observing the benefits and efficiency of the online medium early on. Being an artist and a songwriter as well, he has more than 10 releases to his name with more than 2,00,000 streams across platforms.
                    
                  </p>
                <p>
                His experience of more than a thousand live shows including folk, rock, blues, and instrumental performances has helped <b>Ukulele Seekho's</b> curriculum develop into a perfect mix of performing arts intelligence and theoretical knowledge.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Faculty Section */}
      {/* <section className="relative bg-gradient-to-b from-primary via-primary/95 to-primary/90 py-32">
        <div className="absolute inset-x-0 top-0 h-20 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.45),_transparent_60%)]" />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-[radial-gradient(circle_at_bottom,_rgba(255,255,255,0.25),_transparent_65%)]" />

        <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal className="text-center space-y-5 mb-20">
            <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/45 font-semibold">
              Expert Team
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-accentNavy">
              Meet Your Faculty
            </h2>
            <p className="mx-auto max-w-3xl text-lg text-accentNavy/70 leading-relaxed">
              Our passionate instructors bring years of experience, diverse musical backgrounds,
              and a shared commitment to your growth as a musician.
            </p>
          </Reveal>

          <div className="space-y-24">
            {FACULTY_MEMBERS.map((faculty, index) => {
              const isEven = index % 2 === 0;
              return (
                <Reveal key={faculty.id} delay={index * 100}>
                  <div
                    className={`grid lg:grid-cols-2 gap-12 lg:gap-16 items-center ${
                      isEven ? "" : "lg:grid-flow-dense"
                    }`}
                  >
                    <div
                      className={`relative ${isEven ? "lg:order-1" : "lg:order-2"}`}
                    >
                      <div className="relative aspect-[4/4] max-w-xs sm:max-w-sm md:max-w-md mx-auto lg:max-w-lg group">
                        <img
                          src={faculty.image}
                          alt={faculty.name}
                          className="w-full h-full object-cover rounded-[40px] shadow-[0_50px_100px_-30px_rgba(9,32,63,0.6)] transition-transform duration-700 group-hover:scale-[1.02]"
                        />
                        <div className="absolute inset-0 rounded-[40px] bg-gradient-to-t from-accentNavy/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                        <div className={`absolute -bottom-6 ${isEven ? "-right-6" : "-left-6"} w-32 h-32 bg-accentGold/20 rounded-full blur-2xl`} />
                        <div className={`absolute -top-6 ${isEven ? "-left-6" : "-right-6"} w-40 h-40 bg-accentNavy/10 rounded-full blur-2xl`} />
                      </div>
                    </div>

                    <div className={`space-y-6 ${isEven ? "lg:order-2" : "lg:order-1"}`}>
                      <div className="space-y-3">
                        <p className="text-xs uppercase tracking-[0.2em] text-accentGold font-semibold">
                          {faculty.role}
                        </p>
                        <h3 className="text-3xl sm:text-4xl font-semibold text-accentNavy">
                          {faculty.name}
                        </h3>
                      </div>

                      <p className="text-lg text-accentNavy/70 leading-relaxed">
                        {faculty.bio}
                      </p>

                      <div className="pt-4 border-t border-accentNavy/10">
                        <p className="text-sm font-semibold uppercase tracking-[0.15em] text-accentNavy/60 mb-4">
                          Specializes In
                        </p>
                        <div className="flex flex-wrap gap-3">
                          {faculty.specialties.map((specialty, idx) => (
                            <span
                              key={idx}
                              className="px-4 py-2 rounded-full bg-white/80 border border-accentNavy/10 text-sm font-medium text-accentNavy/80 hover:border-accentGold hover:text-accentGold transition-colors duration-300"
                            >
                              {specialty}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default AboutPage;

